import React, { useEffect, useState } from "react";
import '../css/aurm_sku_qr_display.css'; 
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const DISCOVERY_DOCS = ["https://sheets.googleapis.com/$discovery/rest?version=v4"];
const SCOPES = "https://www.googleapis.com/auth/spreadsheets.readonly";


function AurmSkuQrDisplay() {
  const [data, setData] = useState([]);
  const [params, setParams] = useState([]);
  const [isSheetData, setIsSheetData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [error, setError] = useState(null);

  // Load Google OAuth and fetch sheet data
  useEffect(() => {
    const loadGoogleAuth = async () => {
      if (!window.google) {
        setError("Google API not loaded");
        setIsLoading(false);
        return;
      }

      const tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: process.env.REACT_APP_SCOPES,
        callback: async (resp) => {
          if (resp.access_token) {
            setIsAuthorized(true);

            // After authorization, fetch sheet data
            try {
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.has("ROW_NUM")) {
                setIsSheetData(true);
                const row = urlParams.get("ROW_NUM") || "5";

                const res = await fetch(`/api/sheet?ROW_NUM=${row}`);
                const contentType = res.headers.get("content-type") || "";

                if (!res.ok) throw new Error(`API failed: ${res.status}`);
                if (contentType.includes("application/json")) {
                  const json = await res.json();
                  setData(json.data || []);
                } else {
                  const text = await res.text();
                  console.error("Expected JSON but got HTML:", text);
                  throw new Error("API did not return JSON");
                }
              } else {
                setIsSheetData(false);
                setParams(Array.from(new URLSearchParams(window.location.search).entries()));
              }
            } catch (err) {
              console.error(err);
              setData([]);
              setParams([]);
              setError(err.message);
            } finally {
              setIsLoading(false);
            }
          } else {
            setError("Failed to get access token");
            setIsLoading(false);
          }
        },
      });

      // Request access token (popup login)
      tokenClient.requestAccessToken();
    };

    loadGoogleAuth();
  }, []);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
    <div className="container">
      <div id="sku_params_heading">AURM SKU GET</div>
      <table className="sku_paramsTable">
        <thead>
          <tr>
            <th className="sku_params_tbl_headers">Parameter</th>
            <th className="sku_params_tbl_headers">Value</th>
          </tr>
        </thead>
        <tbody>
          {isSheetData
            ? data.length > 0
              ? data.map((rowData, rowIndex) =>
                  rowData.length > 0 ? (
                    <React.Fragment key={rowIndex}>
                      {rowData.slice(0, 9).map((cell, cellIndex) => (
                        <tr key={cellIndex}>
                          <td>
                            {[
                              "Site",
                              "Asset Tag No",
                              "Item",
                              "SKU",
                              "Supplier/Manuf",
                              "Receiving Stn",
                              "GRN No",
                              "GRN Date",
                              "Issued by",
                            ][cellIndex]}
                          </td>
                          <td>{cell}</td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ) : (
                    <tr key={rowIndex}>
                      <td colSpan="2">No data found for this row</td>
                    </tr>
                  )
                )
              : (
                <tr>
                  <td colSpan="2">No data found</td>
                </tr>
              )
            : params.length > 0
            ? params.map(([key, value], index) => (
                <tr key={index}>
                  <td>{key}</td>
                  <td>{value}</td>
                </tr>
              ))
            : (
                <tr>
                  <td colSpan="2">No data found</td>
                </tr>
              )}
        </tbody>
      </table>
    </div>
  );
}

export default AurmSkuQrDisplay;
